var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIconFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Organization / Status / checkmark--filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.5C5.1 1.5 1 5.6 1 10.5C1 15.4 5.1 19.5 10 19.5C14.9 19.5 19 15.5 19 10.5C19 5.5 15 1.5 10 1.5ZM8.7 14L5.5 10.8L6.5 9.8L8.7 12L13.5 7.2L14.5 8.2L8.7 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Inner Fill",
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7 14.0002L5.5 10.8002L6.5 9.8002L8.7 12.0002L13.5 7.2002L14.5 8.2002L8.7 14.0002Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconFilled);
export default __webpack_public_path__ + "static/media/check-icon-filled.d1c7e6d837066cbea6a8dec13758bc18.svg";
export { ForwardRef as ReactComponent };